// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pre-line[data-v-194eda6d] {\n  white-space: pre-line;\n}\n", ""]);
// Exports
module.exports = exports;
